import { traitStakingContract } from "config";
import { BigNumber } from "ethers";
import { useContractRead } from "wagmi";

const useStakedTraits = (
  tokenId?: number
): [number[] | undefined, () => void] => {
  let stakedTraits;

  const [{ data: traitsData }, readBearStats] = useContractRead(
    {
      addressOrName: traitStakingContract.address,
      contractInterface: traitStakingContract.interface,
    },
    "getStakedTraits",
    {
      args: [tokenId],
    }
  );

  if (traitsData?.[0]) {
    stakedTraits = (traitsData[0] as BigNumber[])
      .map((tokenId) => BigNumber.from(tokenId).toNumber())
      .filter((tokenId) => tokenId > 0);
  }

  return [stakedTraits, readBearStats];
};

export default useStakedTraits;
